export const ATTACHMENTS_FILESTACK_LOAD_START   = 'ATTACHMENTS_FILESTACK_LOAD_START';
export const ATTACHMENTS_FILESTACK_SUCCESS = 'ATTACHMENTS_FILESTACK_SUCCESS';
export const ATTACHMENTS_CREATE_START   = 'ATTACHMENTS_CREATE_START';
export const ATTACHMENTS_DELETE_START   = 'ATTACHMENTS_DELETE_START';
export const ATTACHMENTS_SHOW_START   = 'ATTACHMENTS_SHOW_START';
